import { render, staticRenderFns } from "./details-dialog.vue?vue&type=template&id=befed0c2"
import script from "./details-dialog.vue?vue&type=script&lang=js"
export * from "./details-dialog.vue?vue&type=script&lang=js"
import style0 from "./details-dialog.vue?vue&type=style&index=0&id=befed0c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports